import { Snackbar, Typography } from '@mui/material';
import React from 'react';

import * as Styled from './Toast.styles';

const APPARENT_TIME = 6000;

const Toast = ({ type = 'error', message, isOpen, onClose, innerKey }) => {
  const typeText = type === 'error' ? 'Error' : 'Success';
  return (
    <Snackbar
      autoHideDuration={APPARENT_TIME}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isOpen}
      onClose={onClose}
      message={message}
      key={innerKey}
    >
      <Styled.Alert>
        <Styled.AlertIconWrapper>
          <Styled.AlertIcon variant="closeCircleGradient" />
        </Styled.AlertIconWrapper>
        <Styled.Content>
          <Typography variant="h4">{typeText}</Typography>
          <Styled.Message>{message}</Styled.Message>
        </Styled.Content>
      </Styled.Alert>
    </Snackbar>
  );
};

export default Toast;
